import React, { useEffect, useRef } from "react";
import "./MemberShipScrollNew.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function MemberShipScrollNew({ cardData, noContent = false }) {
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const progressFillRef = useRef(null);
  const progressThumbRef = useRef(null);

  const cards = cardData || [
    {
      img: "/images/creatives/scrollslider-new-img-1.png",
      title: "Comprehensive Medical History Collection",
      para: "We begin by understanding your personal and family medical history to establish a strong clinical foundation.",
      number: "01",
      id: 1,
    },
    {
      img: "/images/creatives/scrollslider-new-img-2.png",
      title: "Multidisciplinary Health Assessments",
      para: "Our executive assessment includes:",
      number: "02",
      id: 2,
      shiftRow: true,
      listPoints: true,
    },
    {
      img: "/images/creatives/scrollslider-new-img-3.png",
      title: "Personalized Health Strategy",
      para: "Your results are reviewed and synthesized into a tailored Health Action Plan, focusing on both risk mitigation and health optimization.",
      number: "03",
      id: 3,
      shiftRow: true,
    },
    {
      img: "/images/creatives/scrollslider-new-img-4.png",
      title: "Ongoing Care and Monitoring",
      para: "Through monthly follow-ups, our clinical team proactively manages your care, adjusting for any changes and helping you stay accountable to your goals.",
      number: "04",
      id: 4,
      shiftRow: true,
    },
    {
      img: "/images/creatives/scrollslider-new-img-5.png",
      title: "24/7 Access and Continuous Support",
      para: "From prescription renewals to acute concerns and health navigation abroad, you’re never on your own.",
      number: "05",
      id: 5,
      shiftRow: true,
    },
    {
    img: "/images/creatives/scrollslider-new-img-6.png",
    title: "Curious to learn more?",
    para:' Want to better understand our program? Book a call with our team to get all your questions answered. You can also download our Prevention Booklet to explore how we help clients stay at their best year after year.',
    number:"06",
    id: 6,
    shiftRow:true,
    btn:"Explore membership",
    lastCard:true
  },

  ];

  useEffect(() => {
    const sections = gsap.utils.toArray(".card-panel");
    const track = trackRef.current;

    // horizontal scroll
    gsap.to(sections, {
    //   xPercent: -100 * (sections.length - 1),
    xPercent: -101 * (sections.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: containerRef.current,
        pin: true,
        scrub: 1,
        snap: {
          snapTo: (value) =>
            Math.round(value * (sections.length - 1)) / (sections.length - 1),
          duration: 0.5,
          ease: "power1.inOut",
        },
        start: "bottom bottom",   
        end: () => "+=" + track.offsetWidth,
     onUpdate: (self) => {
  if (progressFillRef.current && progressThumbRef.current) {
    const totalWidth = progressFillRef.current.parentElement.offsetWidth;

    // Start at middle (50% of first slide), end at middle (50% of last slide)
    const startOffset = 3 / cards.length; // middle of first slide
    const endOffset = 1 - 0.5 / cards.length; // middle of last slide

    const adjustedProgress = startOffset + self.progress * (endOffset - startOffset);

    // Update blue bar
    progressFillRef.current.style.transform = `scaleX(${adjustedProgress})`;

    // Update thumb
    progressThumbRef.current.style.left = `${
      adjustedProgress * totalWidth - progressThumbRef.current.offsetWidth / 2
    }px`;
  }
}




      },
    });

    return () => ScrollTrigger.getAll().forEach((st) => st.kill());
  }, [cards]);

  return (
    <div className="slider-wrapper MemberShipScrollNew" >
      <div className="container pt-5">
        {!noContent && (
          <div className="row" >
            <div className="col-lg-6">
              <div className="d-flex align-items-center gap-2 my-3">
                <h3 className="body-heading">
                  A Clear Path Toward <br />
                  Your <span className="color-blue">Optimal Health</span>
                </h3>
                <img
                  src="/images/icons/icon-logo.png"
                  className="img-fluid"
                  style={{ maxWidth: "100px" }}
                  alt="icon"
                />
              </div>
              <p className="body-paragraph">
                Our program follows a step-by-step, data-driven methodology to
                create lasting transformation in your health and well-being.
              </p>
            </div>
          </div>
        )}
      </div>

      <section
        className="carousel-section "
        ref={containerRef}
        style={{ overflow: "hidden" }}
      >
        <div
          className="carousel-track d-flex "
          ref={trackRef}
          style={{ width: `${cards.length * 100}vw` }}
        >
          {cards.map((card) => (
            <div
              className="card-panel"
              key={card.id}
              style={{ flex: "0 0 100vw", height: "100vh" }}
            >
              <div className="container my-lg-0 my-2">
                <div
                  className={`row gy-lg-0 gy-4 pt-4 ${
                    card?.shiftRow ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="col-lg-6">
                    <div className="card-box p-4">
                      <h5 className="sub-heading color-blue">
                        Step {card.number}
                      </h5>
                      <h3 className="body-heading" style={{ fontSize: "1.6rem" }}>
                        {card.title}
                      </h3>
                      <p className="body-paragraph">{card.para}</p>
                      {card?.listPoints && (
                        <div className="d-flex align-items-start gap-1">
                          <ul>
                            <li>Executive Medical</li>
                            <li>Cardiovascular Risk</li>
                            <li>Cancer Risk</li>
                            <li>Women’s and Men’s Health</li>
                          </ul>
                          <ul>
                            <li>Stress and Wellness</li>
                            <li>Nutrition</li>
                            <li>Fitness and Physiology</li>
                            <li>Naturopathic Assessment</li>
                            <li>Sports Medicine</li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex">
                    {/* <img
                      src={card.img}
                      alt="content"
                      className="img-fluid mx-auto"
                      style={{ borderRadius: "20px" }}
                    /> */}
                    <div className='' style={{ backgroundImage:`url(${card?.img})`,backgroundSize:"cover",backgroundRepeat:"no-repeat",borderRadius: "20px",boxShadow: "0px 3px 10px 2px rgba(0,0,0,0.16)",  width:"100%", maxHeight:"450px",minHeight:"380px" }}>

                        </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Progress bar */}
{/* <div className="scroll-progress-container pb-5" >
  <div
    className="scroll-progress-track"
    style={{
      background: "#bdbdbdff", 
      height: "5px",
      borderRadius: "3px",
      width: "100%",
      transform:"translateX(50%)"
    }}

  />
  <div
    className="scroll-progress-fill"
    ref={progressFillRef}
    style={{
      position: "absolute",
      top: "0",
      left: "0",
      height: "5px",
      background: "#208AE7",
      borderRadius: "3px",
      transformOrigin: "left center",
      transform: "scaleX(0)", 
      width: "100%",
    }}
  />
  <div
    className="scroll-progress-thumb"
    ref={progressThumbRef}
    style={{
      width: "16px",
      height: "16px",
      backgroundColor: "#208AE7",
      borderRadius: "50%",
      position: "absolute",
      top: "3px",
      left: "0px",
    }}
  />
</div> */}

      </section>
    </div>
  );
}

export default MemberShipScrollNew;
